import { ErrorLink, onError } from '@apollo/client/link/error';
/**
 * Not an option in this case since this isn't a react hook
 */
// eslint-disable-next-line no-restricted-syntax
import { handleSessionTermination } from 'src/services/auth/session/hooks/utils/handleSessionTermination';
import { isNetworkErrorInResponse } from '../../utils/isNetworkErrorInResponse';
import { isUnauthenticatedError } from './utils/isUnauthenticatedError';
import { logUnauthenticatedResponseError } from './utils/logUnauthenticatedResponseError';
import { logOperationError } from './utils/logOperationError';
import { isUnauthorizedError } from './utils/isUnauthorizedError';
import { logUnauthorizedResponseError } from './utils/logUnauthorizedResponseError';

export const GRAPHQL_SIGN_OUT_MESSAGE = 'An error has occurred. Please log in again';

declare global {
    // eslint-disable-next-line no-var
    var signOutAlerted: boolean;
    interface Window {
        isDebugMode?: boolean;
    }
}

export const onErrorHandler: ErrorLink.ErrorHandler = payload => {
    const { graphQLErrors } = payload;
    if (graphQLErrors && isNetworkErrorInResponse(graphQLErrors)) {
        return;
    }
    if (isUnauthenticatedError(graphQLErrors)) {
        logUnauthenticatedResponseError(payload);
    } else if (isUnauthorizedError(graphQLErrors)) {
        logUnauthorizedResponseError(payload);
    } else {
        logOperationError(payload);
    }
    if (isUnauthenticatedError(graphQLErrors) || isUnauthorizedError(graphQLErrors)) {
        handleSessionTermination('Unauthorized/Unauthenticated response from server', GRAPHQL_SIGN_OUT_MESSAGE);
    }
};
const createOnErrorLink = () => {
    // this is called once per page load, and lets us avoid alerting N times for N 4xx errors
    globalThis.signOutAlerted = false;
    return onError(onErrorHandler);
};
export { createOnErrorLink };
